import { useEffect, useState } from 'react';
import { forkJoin } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { useSnackbar } from "notistack";
import { ProjectDetails } from 'Models';
import { ProjectDetailsService } from 'Services';

export function useProjectDetails() {
    const [projectDetails, setProjectDetails] = useState<ProjectDetails[]>([]);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        const observable = forkJoin({
            projectDetails: ProjectDetailsService.GetProjectDetails()
        });
        observable.pipe(
            tap(response => {
                setProjectDetails(response.projectDetails);
            }),
            catchError(error => {
                enqueueSnackbar(error.toString(), { variant: 'error' });
                return Promise.reject(error);
            })
        ).subscribe();
    }, [setProjectDetails, enqueueSnackbar]);

    return { projectDetails, setProjectDetails };
}


